import { DEVICE_STATUS } from '../../constants/devices/deviceStatuses'
import { LOAD_DEVICE_DETAILS } from '../../constants/commonEvents'

const SemVerGte = require('semver/functions/gte')
angular
  .module('surfsightApp.controllers')

  .controller('EdgeRecordingsTimelineController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeFactoryV2',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeFactoryV2
    ) {
      const $translate = $filter('translate')
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $mdSidenav('recordings-timeline-container').open()
      }
      const imei = $stateParams.imei
      $scope.timelineInfo = {
        checking: false,
        showTimeline: false,
        imei
      }
      const initRecordingTimeline = async () => {
        $scope.timelineInfo.checking = true
        $scope.timelineInfo.showTimeline = false
        const {
          item: { firmwareVersion }
        } = edgeFactoryV2.findItemByImei(imei)

        if ($scope.edge.status !== DEVICE_STATUS.OFFLINE) {
          const canPlayTimeline = SemVerGte(
            firmwareVersion,
            window.CAN_PLAY_RECORDING_STREAM_VERSION
          )
          $scope.timelineInfo.checking = false
          if (canPlayTimeline) {
            $scope.timelineInfo.showTimeline = true
          } else {
            $state.go('home.common.recordings.list', { imei })
          }
        } else {
          showMessageToast(
            $translate('recordingsAreNotAvailableAsTheCameraIsOffline')
          )
        }
      }
      const showMessageToast = message => {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)
        $mdToast
          .show(toast)
          .then(() => {})
          .catch(() => {})
      }
      if (imei) {
        let edge = edgeFactoryV2.findItemByImei(imei)
        if (edge && edge.item) {
          $scope.edge = edge.item
          initRecordingTimeline()
        } else {
          $scope.$emit(LOAD_DEVICE_DETAILS.REQUEST, { imei })
          const canceller = $scope.$on(LOAD_DEVICE_DETAILS.RESPONSE, function (
            e,
            data
          ) {
            if (data.imei === imei) {
              edge = edgeFactoryV2.findItemByImei(imei)
              $scope.edge = edge.item
              canceller()
              initRecordingTimeline()
            }
          })
        }
      } else {
        $state.go('home.common.recordings')
      }
    }
  ])
